import dayjs from 'dayjs';

const shareFormatter = new Intl.NumberFormat(undefined, { style: 'percent', maximumFractionDigits: 2 });

export function formatShare(share: number) {
  return shareFormatter.format(share);
}

export function formatTimestamp(value: string | null) {
  return value && dayjs(value).isValid() ? dayjs(value).format('D MMM YYYY, HH:mm:ss Z') : 'Not available';
}
